import render from './render'

export default {
  name: 'Template',

  render
}
